const API = process.env.REACT_APP_API_URL || '/api';
const userEndpoints = {
  details: (email) => `${API}/user?email=${email}`,  // Correct endpoint for fetching user details
  getUserFamily: (email) => `${API}/user/userFamily?email=${email}`,
  getUserFamilyDonations: (email) => `${API}/user/userFamilyDonations?email=${email}`,
  update: `${API}/user/update`,  // Correct endpoint for updating user profile
  updateUserAddress: `${API}/user/address-update`,
  checkMobileEligibility: `${API}/user/check-mobile-eligibility`,
  notifyMobileLinked: `${API}/user/notify-mobile-linked`,
  updatePassword: `${API}/auth/update-password`,
  getMessages: (email) => `${API}/messages?email=${email}`,
};

const userFamilyEndpoints = {
  createUserFamily: `${API}/user-family/create`,
  updateUserFamily: `${API}/user-family/update`,
  updateUserFamilyAddress: `${API}/user-family/address-update`,
  getUserFamilyById: (id) => `${API}/user-family?id=${id}`, //fetch  family by id

  createUserFamilyMember: `${API}/user-family-member/create`,
  updateUserFamilyMember: `${API}/user-family-member/update`,
  getUserFamilyMemberById: (id) => `${API}/user-family-member?id=${id}`,
};

const authEndpoints = {
  signin: `${API}/auth/signin`,
  signup: `${API}/auth/signup`,
  verifyEmail: `${API}/auth/verify-email`,
  deviceRegistration: `${API}/auth/device-registration`,
  logout: `${API}/auth/logout`,
  challenge: `${API}/webauth/challenge`,
  updateCredential: `${API}/webauth/update-credential`,
  updateBackendSession: `${API}/webauth/verify-authentication`,
};

const familyEndpoints = {
  queryFamilies: `${API}/family/recent`,
  createFamily: `${API}/family/create`,
  updateFamily: `${API}/family/update`,
  activateFamily: `${API}/family/activate`,
  updateFamilyAddress: `${API}/family/address-update`,
  getFamilyById: (id) => `${API}/family?id=${id}`, //fetch  family by id

  queryFamiliesByFamilyIdRange: `${API}/family-query/FamilyIdRange`,
  queryFamiliesByArea: `${API}/family-query/ByArea`,

  queryFamilyMembers: `${API}/family-member/recent`,
  createFamilyMember: `${API}/family-member/create`,
  updateFamilyMember: `${API}/family-member/update`,
  activateFamilyMember: `${API}/family-member/activate`,
  bulkMoveFamilyMembers: `${API}/family-member/bulk-move`,
  getFamilyMemberById: (id) => `${API}/family-member?id=${id}`,
};

const donationEndpoints = {
  queryDonations: `${API}/donation/recent`,
  createDonation: `${API}/donation/create`,
  createEventDonation: `${API}/donation/createEventDonation`,
  updateDonation: `${API}/donation/update`,
  getFamilyDonations: `${API}/donation/getFamilyDonations`,
  getCategoryDonations: `${API}/donation/getCategoryDonations`,
  queryFamilyForDonation: `${API}/donation/queryFamilyForDonation`,
};

const expenseEndpoints = {
  createExpense: `${API}/expense/create`,
  approveExpense: `${API}/expense/approve`,
  markPaidExpense: `${API}/expense/markPaid`,
  viewExpense: `${API}/expense/view`,
};
const statementEndpoints = {
  getMonthlyStatement: `${API}/statements/monthly`,
  getCategoryStatement: `${API}/statements/category`,
};
const addressEndpoints = {
  queryAddresses: `${API}/address/recent`,
  createAddress: `${API}/address/create`,
  updateAddress: `${API}/address/update`,
  getAddressById: (id) => `${API}/address?id=${id}`, //fetch  family by id

  queryAddressAreas: `${API}/address-area/recent`,
  createAddressArea: `${API}/address-area/create`,
  updateAddressArea: `${API}/address-area/update`,
  updateAddressSubArea: `${API}/address-area/update-sub-area`,
  getAddressAreaById: (id) => `${API}/address-area?id=${id}`, //fetch  family by id
  getAddressAreaByPin: (pincode, withSubAreasOnly) => `${API}/address-area/query-by-pin?pincode=${pincode}&withSubAreasOnly=${withSubAreasOnly}`,
  getUsedAddressArea: () => `${API}/address-area/query-used-address`,
};

const configEndpoints = {
  queryCategoryConfig: `${API}/category-config/list`,
  createCategoryConfig: `${API}/category-config/create`,
  queryExpenseCategoryConfig: `${API}/category-config/expense-list`,
};
const eventsEndpoints = {
  queryEvents: `${API}/events`,
  queryUserEvents: `${API}/events/userEvents`,
  createEvent: `${API}/events/create`,
  updateEvent: (id) => `${API}/events/update/${id}`,
  getEventById: (id) => `${API}/events/${id}`,
  getUserEventById: (id) => `${API}/events/userEvent/${id}`,
  deleteEvent: (id) => `${API}/events/delete/${id}`,
};

const translateTextEndpoints = {
  translateText: `${API}/translate/translateText`, //fetch recent  list
};

const fileEndpoints = {
  createFamilyFileUploadUrl: `${API}/file/create-family-url`,
  getFamilyFileDownladUrl: `${API}/file/get-family-url`,
};
const contactEndpoints = {
  sendBulkSms: `${API}/contact-management/bulk-sms-send`,
  checkDeliveryStatusBulkSms: `${API}/contact-management/check-sms-delivery-status`,
  sendBulkMobileStatusUpdate: `${API}/contact-management/bulk-update-mobile-status`,
};
export {
  authEndpoints, userEndpoints, userFamilyEndpoints, familyEndpoints, eventsEndpoints, addressEndpoints
  , translateTextEndpoints, configEndpoints, donationEndpoints, expenseEndpoints, statementEndpoints
  , fileEndpoints
  , contactEndpoints
};